import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import '../../assets/stylesheets/Game3.scss';
import Modal from 'react-modal';

@inject('Game3Store','Navigator')
@observer
export default class Guidelines extends Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            numberOfGuideLines: 1
        };
    }

    handleClose() {
        this.props.Navigator.push("/")
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.props.Game3Store.showGuidelines = false;
        this.setState({modalIsOpen: false});
    }


    handleNextStep() {

        if ( this.state.numberOfGuideLines === this.props.Game3Store.players.length) {
            this.closeModal();
        } else {
            let num = this.state.numberOfGuideLines + 1;
            this.setState({numberOfGuideLines: num});
            if ( this.state.numberOfGuideLines < this.props.Game3Store.players.length) {
                return;
            }
        }
    }

    render() {

        const customStyles = {
            overlay : {
                position          : 'fixed',
                top               : 0,
                left              : 0,
                right             : 0,
                bottom            : 0,
                backgroundColor   : 'black'
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                background            : 'black',
                color                 : 'white'
            }
        };

        let players = this.props.Game3Store.players;

        let player = players[this.state.numberOfGuideLines-1];

        const tasksEl = player.tasks.map(
            (task, index) => <div className="question" key={index}>
                {task.statement.image &&
                <div className="question-image"
                     style={{backgroundImage: `url(images/${task.statement.image}.jpg)`}}/>
                }
                <div className="question-statement">
                    <label className="label-task-guideline">Task {index+1}</label>
                    <p className={index === 3 ? "p-task4" : "" }><strong>{task.name}</strong> <br/>{task.statement.statement}</p>
                </div>
            </div>
        );

        let labelButton = 'Close';

        if ( this.state.numberOfGuideLines < this.props.Game3Store.players.length) {
            labelButton = 'Next Team';
        }

        return (
            <div className="Game3 Page">
                <Modal
                    isOpen={this.state.modalIsOpen}
                    style={customStyles}
                    contentLabel="Modal"
                >
                    <h1>Would you like to leave the game?</h1>
                    <button className="btn-modal"
                        onClick={this.handleClose.bind(this)}>YES
                    </button>
                    <button className="btn-modal right"
                        onClick={this.closeModal.bind(this)}>NO
                    </button>
                </Modal>
                <div className="Close">
                    <button className="btn-close"
                        onClick={this.openModal.bind(this)}>X
                    </button>
                </div>
                <div className="step-4">
                    <h1>Guidelines</h1>
                    <br/>
                    <div className={"team-name " + player.team.color}>{player.name}</div>
                    {tasksEl}
                </div>
                <div className="nav">
                    <button
                        className={"btn-nav-next" }
                        onClick={this.handleNextStep.bind(this)}>{labelButton}</button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/Game3/Guidelines.js